module.exports = __webpack_public_path__ + "img/assessmentPlan.93dc8f6b.svg";